import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { Plus, ArrowRight } from 'lucide-react'
import { PageShell } from '../../components/layout/PageShell'

export function FaqPage() {
  const { t } = useTranslation()
  const { locale: routeLocale = 'it' } = useParams()
  const items = [1, 2, 3, 4, 5, 6, 7]

  return (
    <PageShell>
      <div className="mb-6">
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-ink-900 sm:text-3xl">{t('home.faqTitle')}</h1>
        <p className="mt-1.5 text-sm text-ink-500">{t('home.subtitle')}</p>
      </div>

      <div className="space-y-2.5">
        {items.map((i) => (
          <details key={i} className="group rounded-2xl bg-white p-4 shadow-card ring-1 ring-ink-100 sm:p-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-3 font-semibold text-ink-900">
              {t(`home.faqQ${i}`)}
              <Plus className="h-4 w-4 flex-none text-ink-400 transition-transform group-open:rotate-45" />
            </summary>
            <p className="mt-2.5 text-sm leading-relaxed text-ink-500">{t(`home.faqA${i}`)}</p>
          </details>
        ))}
      </div>

      <Link
        to={`/${routeLocale}/book`}
        className="mt-7 inline-flex h-12 items-center gap-2 rounded-xl bg-brand-600 px-5 text-sm font-bold text-white transition hover:bg-brand-700"
      >
        {t('home.book')} <ArrowRight className="h-4 w-4" />
      </Link>
    </PageShell>
  )
}
